module.exports = __webpack_public_path__ + "static/media/fal_fal_ris_ass_and_saf_pla.d30a8fb5.png";